<script setup lang="ts">
defineProps<{
  userName?: string;
  userProfilePicUrl?: string;
}>();
</script>

<template>
  <div class="flex items-center gap-3 p-2">
    <div class="font-medium">@{{ userName }}</div>
    <div v-if="userProfilePicUrl" class="shrink-0">
      <img
        :src="userProfilePicUrl"
        alt="User Profile Picture"
        class="w-12 h-12 max-w-16 max-h-16 rounded-full object-cover"
      />
    </div>
  </div>
</template>
